import { render, staticRenderFns } from "./namespace_token.vue.js?vue&type=template&id=70c5ca81!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./namespace_token.vue?vue&type=template&id=70c5ca81"
import script from "./namespace_token.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./namespace_token.vue?vue&type=script&lang=js"
export * from "./namespace_token.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./namespace_token.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70c5ca81')) {
      api.createRecord('70c5ca81', component.options)
    } else {
      api.reload('70c5ca81', component.options)
    }
    module.hot.accept("./namespace_token.vue.js?vue&type=template&id=70c5ca81!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./namespace_token.vue?vue&type=template&id=70c5ca81", function () {
      api.rerender('70c5ca81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue_shared/components/filtered_search_bar/tokens/namespace_token.vue"
export default component.exports